import { Badge, Group } from "@mantine/core";
import { capitalize } from "inflection";
import { SocialMediaPlatform } from "../../types/request.types";
import platformIcons from "../icons/platformIcons";

interface PlatformBadgeProps {
  platform: SocialMediaPlatform;
}

export default function PlatformBadge({ platform }: PlatformBadgeProps) {
  const Icon = platformIcons[platform];
  let displayName;

  switch (platform) {
    case 'x':
      displayName = 'X (Twitter)';
      break;
    case 'linkedin':
      displayName = 'LinkedIn';
      break;
    default:
      displayName = capitalize(platform);
  }

  return (
    <Badge variant="light" color="dark.5">
      <Group gap="xs" wrap="nowrap">
        <Icon size={16} />
        {displayName}
      </Group>
    </Badge>
  );
}
